import React from 'react';
import Faq from './faq';

function FAQ() {
  return (
    <div>
      <Faq />
    </div>
  );
}

export default FAQ;